import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as moment from 'moment';
import * as _ from 'lodash';

import { AppService } from '../../app.service';
import { FacilityListEvent, LoaderEvent } from './../../shared/message.event';

import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
  selector: 'app-block-date',
  templateUrl: './block-dates.component.html',
  styleUrls: ['./block-dates.component.css'],
  providers: [LoaderEvent],
  exportAs: 'blockDates'
})
export class BlockDateComponent implements OnInit {
  @ViewChild('childModal') childModal: ModalDirective;
  private utilityFunctions = new UtilityFunctions();
  private stringConstants = CONSTANT_MESSAGES;
  private vendor;
  private facility;
  private selectedFacility = '';
  private blockObj;
  private blockStartTimeHoursList;
  private facilityList = [];
  private blockEndTimeHoursList;
  private validate;
  private minDate;
  private startMaxDate;
  private endMinDate;
  private startMinDate;
  private timezoneOffset;
  private facilityWiseBlockList = {};
  private entryNo = 0;
  private rangeList = [];
  private errorMessage = '';
  private blockButton = true;
  private popUpMessage = '';
  private entirDayCheck = false;
  private minute_values = CONSTANT_VALUES.MINUTE_VALUES;
  private isopen1 = false;
  private isopen2 = false;
  @Output() notifyfetchActivity = new EventEmitter<boolean>();
  @Input() cancleButton;
  @Output() notify = new EventEmitter<boolean>();

  constructor(private loaderEvent: LoaderEvent, private appService: AppService, private facilityListEvent: FacilityListEvent) {
  }

  public showChildModal(): void {
    this.facilityList = [];
    this.facility = '';
    this.facilityWiseBlockList = {};
    this.resetValues();
    this.getFacility();
    this.entryNo = 0;
    this.rangeList = [];
    this.selectedFacility = '';
    this.startMaxDate = '';
    this.errorMessage = '';
    this.blockStartTimeHoursList = [];
    this.blockEndTimeHoursList = [];
    this.makeListForTime();
    this.childModal.config.backdrop = false;
    this.childModal.show();
  }

  public hideChildModal(): void {
    this.childModal.hide();
  }

  ngOnInit() {
    if (localStorage.getItem('vendor')) {
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
      this.timezoneOffset = this.vendor.timezoneOffset * -1;
      this.resetValues();
    }
  }

  ngOnDestroy() {
  }

  blockDates() {
    if (this.validateBlockSlot('')) {
      this.blockObj.startTime = this.blockObj.startTime_hours + ':' + this.blockObj.startTime_minutes;
      this.blockObj.endTime = this.blockObj.endTime_hours + ':' + this.blockObj.endTime_minutes;
      if (this.blockObj.blockStartDate > this.blockObj.blockEndDate) {
        this.errorMessage = CONSTANT_MESSAGES.START_DATE_LESS_ERROR_MSG;
        return;
      }
      if (this.blockObj.blockStartDate > this.blockObj.blockEndDate && !this.blockObj.isFullDay) {
        this.errorMessage = CONSTANT_MESSAGES.START_DATE_LESS_ERROR_MSG;
        return;
      } else if (this.blockObj.startTime >= this.blockObj.endTime && !this.blockObj.isFullDay) {
        this.errorMessage = CONSTANT_MESSAGES.START_TIME_LESS_ERROR_MSG;
        return;
      }

      else if ((this.blockObj.startTime < this.facility.timings.openTime.replace(':00:00', '') || this.blockObj.endTime > this.facility.timings.closeTime.replace(':00:00', '')) && !this.blockObj.isFullDay) {
        this.errorMessage = CONSTANT_MESSAGES.WITHIN_ACTIVITY_TIMINGS_ERROR_MSG;
        return;
      }
      else {
        this.errorMessage = '';
        this.blockObj.isFullDay = this.facility.timings.openTime.indexOf(this.blockObj.startTime_hours + ':' + this.blockObj.startTime_minutes + ':00:00') >= 0 && this.facility.timings.closeTime.indexOf(this.blockObj.endTime_hours + ':' + this.blockObj.endTime_minutes + ':00:00') >= 0 ? true : false;
        this.makeBlockList();
        this.blockButton = false;
      }
    } else {
    }
  }

  makeListForTime() {
    if (this.facility) {
      this.blockStartTimeHoursList = this.utilityFunctions.makeListForTime(this.facility, false)[0];
      this.blockEndTimeHoursList = this.utilityFunctions.makeListForTime(this.facility, false)[1];
    }
  }

  getFacility() {
    let that = this;
    let facilityData = [];
    let vendorAdminId;
    this.loaderEvent.fire(false);
    if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        vendorAdminId = subVendor._id;
      }
    } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
      vendorAdminId = this.vendor.vendorId;
    } else {
      vendorAdminId = this.vendor._id;
    }
    this.appService.getClubFacility({ vendorId: vendorAdminId }).then((result: any) => {
      facilityData = result.facilityData;
      facilityData.forEach(data => {
        data.data.forEach(facility => {
          facility.unitNames.push('All');
          that.facilityList.push(facility);
        });
      });
      this.loaderEvent.fire(true);
    });
  }

  /**
* Facility name will change on selection to disable group
*/
  facilityChange(item) {
    this.isopen2 = true;
    this.selectedFacility = item;
    this.facility = item;
    this.blockStartTimeHoursList = [];
    this.blockEndTimeHoursList = [];
    this.blockObj.startTime = '';
    this.blockObj.startTime_hours = '';
    this.blockObj.startTime_minutes = '';
    this.blockObj.endTime = '';
    this.blockObj.endTime_hours = '';
    this.blockObj.endTime_minutes = '';
    this.facility = this.selectedFacility;
    this.blockObj.facilityName = this.selectedFacility['name'];
    this.blockObj.facilityId = this.selectedFacility ? this.selectedFacility['_id'] : '';
    this.blockObj.isFullDay = false;
    this.entirDayCheck = false;
    this.errorMessage = '';
    console.log('facility', this.facility);
    console.log('facility', this.selectedFacility)
    this.makeListForTime();
  }

  validateBlockSlot(validatePara) {
    let flag = true;
    switch (validatePara) {
      case 'facility':
        this.validate.facility = this.blockObj.facilityId ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        break;
      case 'unitName':
        this.validate.unitName = this.blockObj.unitNames ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        break;
      case 'blockStartDate':
        this.validate.blockStartDate = this.blockObj.blockStartDate ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        break;
      case 'blockEndDate':
        this.validate.blockEndDate = this.blockObj.blockEndDate ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        break;
      case 'startTime_hours':
        this.validate.startTime_hours = this.blockObj.startTime_hours || this.blockObj.isFullDay ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        break;
      case 'startTime_minutes':
        this.validate.startTime_minutes = this.blockObj.startTime_minutes || this.blockObj.isFullDay ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        break;
      case 'endTime_hours':
        this.validate.endTime_hours = this.blockObj.endTime_hours || this.blockObj.isFullDay ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        break;
      case 'endTime_minutes':
        this.validate.endTime_minutes = this.blockObj.endTime_minutes || this.blockObj.isFullDay ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        break;
      case 'startTime':
        this.validate.startTime = this.blockObj.startTime || this.blockObj.isFullDay ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        break;
      case 'endTime':
        this.validate.endTime = this.blockObj.endTime || this.blockObj.isFullDay ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        break;
      case '':
        this.validate.facility = this.blockObj.facilityId ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.unitName = this.blockObj.unitNames ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.blockStartDate = this.blockObj.blockStartDate ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.blockEndDate = this.blockObj.blockEndDate ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.startTime_hours = this.blockObj.startTime_hours || this.blockObj.isFullDay ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.startTime_minutes = this.blockObj.startTime_minutes || this.blockObj.isFullDay ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.endTime_hours = this.blockObj.endTime_hours || this.blockObj.isFullDay ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.endTime_minutes = this.blockObj.endTime_minutes || this.blockObj.isFullDay ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        flag = this.blockObj.facilityId && this.blockObj.blockStartDate && this.blockObj.unitNames && this.blockObj.blockEndDate && (this.blockObj.startTime_minutes || this.blockObj.isFullDay) && (this.blockObj.startTime_hours || this.blockObj.isFullDay) && (this.blockObj.endTime_hours || this.blockObj.isFullDay) && (this.blockObj.endTime_minutes || this.blockObj.isFullDay) ? true : false;
        break;
    }
    return flag;
  }

  resetValues() {
    this.validate = {
      'facility': '',
      'blockStartDate': '',
      'blockEndDate': '',
      'startTime': '',
      'endTime': '',
      'startTime_hours': '',
      'startTime_minutes': '',
      'endTime_hours': '',
      'endTime_minutes': ''
    }
    this.blockObj = {
      'blockStartDate': new Date(),
      'blockEndDate': new Date(),
      'tempStart': moment().format('dd/mm/yyyy'),
      'tempEnd': moment().format('dd/mm/yyyy'),
      'showStart': moment().format('mm/dd/yyyy'),
      'showEnd': moment().format('mm/dd/yyyy'),
      'startTime': '',
      'endTime': '',
      'startTime_hours': '',
      'startTime_minutes': '',
      'endTime_hours': '',
      'endTime_minutes': '',
      'facilityId': '',
      'isFullDay': false,
      'facilityName': '',
      'unitNames': ''
    }
    let timeZoneDate = moment().utcOffset(this.timezoneOffset);
    let year = timeZoneDate.year(), month = timeZoneDate.month(), date = timeZoneDate.date(), hour = timeZoneDate.hour(), minutes = timeZoneDate.minutes();
    this.blockObj.blockStartDate = (new Date(year, month, date, hour, minutes));
    this.blockObj.blockEndDate = (new Date(year, month, date, hour, minutes));
    this.startMinDate = (new Date(year, month, date, hour, minutes));
    this.endMinDate = (new Date(year, month, date, hour, minutes));
    this.minDate = (new Date(year, month, date, hour, minutes));
    this.selectedFacility = '';
    this.startMaxDate = '';
    this.blockStartTimeHoursList = [];
    this.blockEndTimeHoursList = [];
    this.blockObj.isFullDay = false;
    this.entirDayCheck = false;
  }

  changeEndMinDate(startDate) {
    this.endMinDate = startDate;
  }

  changeStartEndDate(minEndDate) {
    this.startMaxDate = minEndDate;
  }

  makeBlockList() {
    let blockedList = [];
    let momentDateFormat;
    let blockObjTemp;
    let flag = true;
    let blockEndDate = _.cloneDeep(this.blockObj.blockEndDate);
    let blockStartDate = _.cloneDeep(this.blockObj.blockStartDate);
    this.blockObj.tempStart = moment(blockStartDate).format('DD/MM/YYYY');
    this.blockObj.showStart = moment(blockStartDate).format('MM/DD/YYYY');
    this.blockObj.tempEnd = moment(this.blockObj.blockEndDate).format('DD/MM/YYYY');
    this.blockObj.showEnd = moment(this.blockObj.blockEndDate).format('MM/DD/YYYY');
    blockStartDate.setHours(0, 0, 0, 0);
    blockEndDate.setHours(23, 59, 0, 0)
    if (!this.checkBlockSlotAvailability(this.blockObj)) {
      if (this.blockObj.isFullDay) {
        var d = blockStartDate
        for (; d <= blockEndDate; d.setDate(d.getDate() + 1)) {
          blockObjTemp = {
            isFullDay: true,
            date: moment(d).format('DD/MM/YYYY'),
            slots: [],
            note: '',
            unitNames: this.blockObj.unitNames === 'All' ? this.getUnitNameList() : [this.blockObj.unitNames],
            isUnitBlock: true
          }
          momentDateFormat = moment(d).format('DD/MM/YYYY');
          if (this.checkSlotAvailability(momentDateFormat, blockObjTemp)) {
            blockedList.push(blockObjTemp);
            this.entryNo++;
          } else {
            this.errorMessage = CONSTANT_MESSAGES.SLOT_ERROR_1 + this.blockObj.startTime_hours + ':' + this.blockObj.startTime_minutes + ' - ' + this.blockObj.endTime_hours + ':' + this.blockObj.endTime_minutes + CONSTANT_MESSAGES.TEXT_FOR + momentDateFormat + CONSTANT_MESSAGES.SLOT_ERROR_2;
            flag = false;
            break;
          }
        }
      } else {
        let d = blockStartDate;
        for (; d <= blockEndDate; d.setDate(d.getDate() + 1)) {
          blockObjTemp = {
            'start': this.blockObj.startTime_hours + ':' + this.blockObj.startTime_minutes + ':00:00',
            'end': this.blockObj.endTime_hours + ':' + this.blockObj.endTime_minutes + ':00:00',
            'note': ''
          }
          momentDateFormat = moment(d).format('DD/MM/YYYY')
          if (this.checkSlotAvailability(momentDateFormat, blockObjTemp)) {
            blockedList.push({
              isFullDay: false,
              date: momentDateFormat,
              unitNames: this.blockObj.unitNames === 'All' ? this.getUnitNameList() : [this.blockObj.unitNames],
              isUnitBlock: true,
              slots: [
                blockObjTemp
              ],
            });
            this.entryNo++;
          } else {
            this.errorMessage = CONSTANT_MESSAGES.SLOT_ERROR_1 + this.blockObj.startTime_hours + ':' + this.blockObj.startTime_minutes + ' - ' + this.blockObj.endTime_hours + ':' + this.blockObj.endTime_minutes + CONSTANT_MESSAGES.TEXT_FOR + momentDateFormat + CONSTANT_MESSAGES.SLOT_ERROR_2;
            flag = false;
            break;
          }
        }
      }
      if (flag) {
        let rangeObj = _.cloneDeep(this.blockObj);
        this.rangeList.push({
          entryNo: this.entryNo,
          blockObj: rangeObj
        });

        // check here
        //  this.checkSlotAvailability(blockedList);

        if (this.facility._id in this.facilityWiseBlockList) {
          this.facilityWiseBlockList[this.selectedFacility['_id']].data.push({
            'blockList': blockedList,
            'entryNo': this.entryNo
          });
        } else {
          this.facilityWiseBlockList[this.selectedFacility['_id']] = {
            data: [],
            facilityInfo: {
              'facilityName': this.selectedFacility['name'],
              'timings': this.selectedFacility['timings'],
              'timezoneOffset': this.vendor.timezoneOffset
            }
          };
          this.facilityWiseBlockList[this.selectedFacility['_id']].data.push({
            'blockList': blockedList,
            'entryNo': this.entryNo,

          });
        }
      } else {

      }
      this.resetValues();
    } else {
      this.errorMessage = CONSTANT_MESSAGES.SLOT_ERROR_1 + this.blockObj.startTime_hours + ':' + this.blockObj.startTime_minutes + ' - ' + this.blockObj.endTime_hours + ':' + this.blockObj.endTime_minutes + CONSTANT_MESSAGES.SLOT_ERROR_3;
    }
    // end here
  }

  removeBlockSlot(obj) {
    this.facilityWiseBlockList[obj.blockObj.facilityId].data.forEach(data => {
      if (data.entryNo == obj.entryNo) {
        data.blockList = [];
      }
    });
    _.remove(this.rangeList, (dataObj) => {
      return obj.entryNo == dataObj.entryNo;
    });
  }

  blockDatesToServer(popUpObj) {
    let facilityData = [];
    let that = this;
    let slot = {
      'facilityId': ''
    };
    if (this.facilityWiseBlockList) {
      for (let facilityList in this.facilityWiseBlockList) {
        slot['facilityId'] = facilityList;
        slot['name'] = this.facilityWiseBlockList[facilityList].facilityInfo.facilityName;
        slot['timings'] = this.facilityWiseBlockList[facilityList].facilityInfo.timings;
        slot['timezoneOffset'] = this.facilityWiseBlockList[facilityList].facilityInfo.timezoneOffset;
        slot['holidays'] = [];
        this.facilityWiseBlockList[facilityList].data.forEach(element => {
          slot['holidays'] = slot['holidays'].concat(element.blockList);
        });
        facilityData.push(slot);
        slot = {
          'facilityId': ''
        };
      }
      let reqObj = {
        'vendorId': this.vendor._id,
        'facilityData': facilityData ? facilityData : []
      }
      if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
        if (this.vendor.subVendors.length > 0) {
          let subVendor = this.vendor.subVendors[0];
          reqObj.vendorId = subVendor._id;
        }
      } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
        reqObj.vendorId = this.vendor.vendorId;
      } else {
        reqObj.vendorId = this.vendor._id;
      }

      this.errorMessage = '';
      this.loaderEvent.fire(false);
      this.appService.blockDates(reqObj).then((result: any) => {
        if (result.status == CONSTANT_VALUES.RESPONSE_SUCCESS) {
          that.updateFacilityData();
          that.notify.emit(true);
          this.popUpMessage = result.message;
          this.loaderEvent.fire(true);
          this.hideChildModal();
          popUpObj.showChildModal();
        } else {
          that.updateFacilityData();
          this.loaderEvent.fire(true);
          this.popUpMessage = result.message;
          this.hideChildModal();
          popUpObj.showChildModal();
        }
        this.hideChildModal();
        popUpObj.showChildModal();
        this.loaderEvent.fire(true);
      });
      this.errorMessage = '';
    } else {
      this.errorMessage = CONSTANT_MESSAGES.ATLEAST_ONE_SLOT;
    }
  }

  hidePopup() {
    this.hideChildModal();
  }

  checkBlockSlotAvailability(blockObj) {
    let flag = false;
    for (let i = 0; i < this.rangeList.length; i++) {
      if (this.rangeList[i].blockObj.startTime == this.blockObj.startTime_hours + ':' + this.blockObj.startTime_minutes && this.rangeList[i].blockObj.endTime == blockObj.endTime && this.rangeList[i].blockObj.facilityId == blockObj.facilityId && this.rangeList[i].blockObj.tempEnd == blockObj.tempEnd && this.rangeList[i].blockObj.tempStart == blockObj.tempStart && this.rangeList[i].blockObj.unitNames === this.blockObj.unitNames) {
        flag = true;
        break;
      } else {
        flag = false;
      }
    }
    return flag;
  }

  checkSlotAvailability(date, blockObj) {
    let flag = true;
    for (let i = 0; i < this.facility.holidays.length; i++) {
      if (date == this.facility.holidays[i].date && this.blockObj.isFullDay && this.facility.holidays[i].isFullDay && this.facility.holidays[i].unitNames === this.blockObj.unitNames) {
        flag = false;
        break;
      }
      else if (!this.blockObj.isFullDay && this.blockObj.isFullDay == this.facility.holidays[i].isFullDay && blockObj.start == this.facility.holidays[i].slots[0].start && blockObj.end == this.facility.holidays[i].slots[0].end && this.facility.holidays[i].date == date && this.facility.holidays[i].unitNames === this.blockObj.unitNames) {
        flag = false;
        break;
      }
    }
    return flag;
  }

  updateFacilityData() {
    this.facilityWiseBlockList = {};
    let vendorObj: any = {
      vendorId: '',
      showPastData: true
    };
    this.facility = '';
    let that = this;
    if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        vendorObj.vendorId = subVendor._id;
      }
    } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
      vendorObj.vendorId = this.vendor.vendorId;
    } else {
      vendorObj.vendorId = this.vendor._id;
    }
    this.loaderEvent.fire(false);
    this.appService.getClubFacility(vendorObj).then((result: any) => {
      if (result.status == CONSTANT_VALUES.RESPONSE_SUCCESS) {
        this.facilityListEvent.fire(result.facilityData);
        localStorage.setItem('vendor_facilityData', (JSON.stringify(result.facilityData)));
        that.getFacility();
        this.loaderEvent.fire(true);
      } else {
        this.loaderEvent.fire(true);
      }
    });
  }

  blockEntireDay(event) {
    let facilityOpenTime = this.facility.timings.openTime.split(':');
    let facilityCloseTime = this.facility.timings.closeTime.split(':');
    if (event.target.checked) {
      this.blockObj.isFullDay = true;
      this.blockObj.startTime_hours = facilityOpenTime[0];
      this.blockObj.startTime_minutes = facilityOpenTime[1];
      this.blockObj.endTime_hours = facilityCloseTime[0];
      this.blockObj.endTime_minutes = facilityCloseTime[1];
      this.blockObj.startTime = this.facility.timings.openTime ? this.facility.timings.openTime.replace(/:00:00/g, '') : '';
      this.blockObj.endTime = this.facility.timings.closeTime ? this.facility.timings.closeTime.replace(/:00:00/g, '') : '';
      this.validate.startTime = '';
      this.validate.endTime = '';
    } else {
      this.blockObj.isFullDay = false;
      this.blockObj.startTime = '';
      this.blockObj.startTime_hours = '';
      this.blockObj.startTime_minutes = '';
      this.blockObj.endTime = '';
      this.blockObj.endTime_hours = '';
      this.blockObj.endTime_minutes = '';
    }
  }

  setUnitName(unitName) {
    this.blockObj.unitNames = unitName;
  }

  getUnitNameList() {
    let unitNameList = JSON.parse(JSON.stringify(this.selectedFacility['unitNames']));
    return unitNameList.slice(0, unitNameList.length - 1);
  }

  // 24 hour time slot changes
  setMinutes() {
    if (this.blockObj.endTime_hours == '24') {
      this.blockObj.endTime_minutes = '00'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/primecalendar/block-dates/block-dates.component.ts